import styled from '@emotion/styled';
import themeGet from '@styled-system/theme-get';
import { NumberInput } from 'components/Form';
import { FC } from 'react';
import { Box, InputProps } from '@qga/roo-ui/components';

const StyledBox = styled(Box)`
  position: relative;
  padding: 0;

  img {
    position: absolute;
    top: ${themeGet('space.3')};
    right: ${themeGet('space.2')};
    width: 92px;
  }
`;

const NumberInputWithSuffix = styled(NumberInput)`
  padding-right: 112px;
`;

type Props = InputProps;

const InputWithSuffix: FC<Props> = ({ children, ...props }) => (
  <StyledBox>
    <NumberInputWithSuffix {...props} />
    {children}
  </StyledBox>
);

export default InputWithSuffix;
